/**
 * resource-admin sub-app English locale
 *
 * Migrated from skeleton/resource-admin/src/i18n/locales/en.json to Umi Max locale format
 * Uses flat key format (dot notation) as expected by Umi Max locale plugin
 *
 * Requirements: 10.5, 10.6
 */
export default {
  // ============== common ==============
  'common.actions': 'Actions',
  'common.view': 'View',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.create': 'Create',
  'common.new': 'New',
  'common.tree': 'Tree',
  'common.submit': 'Submit',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.back': 'Back',
  'common.backToList': 'Back to List',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.retry': 'Retry',
  'common.refresh': 'Refresh',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.clear': 'Clear',
  'common.apply': 'Apply',
  'common.reset': 'Reset',
  'common.loading': 'Loading...',
  'common.saving': 'Saving...',
  'common.submitting': 'Submitting...',
  'common.initializing': 'Initializing...',
  'common.processing': 'Processing...',
  'common.deleting': 'Deleting...',
  'common.updating': 'Updating...',
  'common.creating': 'Creating...',
  'common.noData': 'No data available',
  'common.noResults': 'No results found',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.optional': 'Optional',
  'common.required': 'This field is required',
  'common.deleteSuccess': 'Deleted successfully',
  'common.deleteFailed': 'Delete failed',
  'common.createSuccess': 'Created successfully',
  'common.createFailed': 'Create failed',
  'common.updateSuccess': 'Updated successfully',
  'common.updateFailed': 'Update failed',
  'common.deleteConfirm': 'Are you sure you want to delete?',

  // ============== menus ==============
  'menus.title': 'Menus',
  'menus.create': 'Create Menu',
  'menus.createFirst': 'Create First Menu',
  'menus.createTitle': 'Create Menu',
  'menus.createDescription': 'Create a new menu with actions and routes',
  'menus.editTitle': 'Edit Menu',
  'menus.editDescription': 'Update menu information, actions, and routes',
  'menus.viewTitle': 'Menu Detail',
  'menus.viewDescription': 'View menu details, actions, and routes',
  'menus.menuInformation': 'Menu Information',
  'menus.menuInformationDescription': 'Basic menu properties and configuration',
  'menus.typeOptions.group': 'Group',
  'menus.typeOptions.menu': 'Menu',
  'menus.typeOptions.divider': 'Divider',
  'menus.actions': 'Actions',
  'menus.actionsDescription': 'Permission-controlled operations for this menu',
  'menus.routes': 'Routes',
  'menus.routesDescription': 'HTTP API endpoints associated with this menu',
  'menus.addAction': 'Add Action',
  'menus.addRoute': 'Add Route',
  'menus.removeAction': 'Remove Action',
  'menus.removeRoute': 'Remove Route',
  'menus.noActions': 'No actions configured',
  'menus.noRoutes': 'No routes configured',
  'menus.externalLink': 'External',
  'menus.internalLink': 'Internal',
  'menus.noParent': 'No Parent (Root Menu)',
  'menus.selectParent': 'Select parent menu',
  'menus.deleteConfirmTitle': 'Delete Menu',
  'menus.deleteConfirmDescription':
    'Are you sure you want to delete "{name}"? This action cannot be undone.',

  // menus fields
  'menus.fields.id': 'Menu ID',
  'menus.fields.name': 'Name',
  'menus.fields.type': 'Type',
  'menus.fields.url': 'URL',
  'menus.fields.icon': 'Icon',
  'menus.fields.serialNumber': 'Serial Number',
  'menus.fields.parentMenu': 'Parent Menu',
  'menus.fields.externalLink': 'External Link',
  'menus.fields.status': 'Status',
  'menus.fields.cache': 'Cache',
  'menus.fields.component': 'Component',
  'menus.fields.partName': 'Part Name',
  'menus.fields.level': 'Level',
  'menus.fields.leaf': 'Is Leaf',
  'menus.fields.code': 'Code',
  'menus.fields.resourceId': 'Resource',
  'menus.fields.actionCode': 'Action Code',
  'menus.fields.actionName': 'Action Name',
  'menus.fields.actionGroup': 'Action Group',
  'menus.fields.actionDescription': 'Action Description',
  'menus.fields.actionSerialNumber': 'Action Serial Number',
  'menus.fields.routeName': 'Route Name',
  'menus.fields.routePath': 'Route Path',
  'menus.fields.routeMethod': 'HTTP Method',

  // menus placeholders
  'menus.fields.namePlaceholder': 'Enter menu name',
  'menus.fields.urlPlaceholder': 'Enter menu URL',
  'menus.fields.iconPlaceholder': 'Enter icon name',
  'menus.fields.codePlaceholder': 'Enter menu code',
  'menus.fields.typePlaceholder': 'Select type',
  'menus.fields.resourceIdPlaceholder': 'Select resource',
  'menus.fields.parentMenuPlaceholder': 'Select parent menu (optional)',
  'menus.fields.serialNumberPlaceholder': 'Enter serial number',
  'menus.fields.componentPlaceholder': 'Enter component path',
  'menus.fields.partNamePlaceholder': 'Enter part name',
  'menus.fields.actionCodePlaceholder': 'menu:action',
  'menus.fields.actionNamePlaceholder': 'Action Name',
  'menus.fields.actionGroupPlaceholder': 'menu',
  'menus.fields.actionDescriptionPlaceholder': 'Describe what this action does',
  'menus.fields.actionSerialNumberPlaceholder': '1',
  'menus.fields.routeNamePlaceholder': 'Get Items',
  'menus.fields.routePathPlaceholder': '/api/v1/items',
  'menus.fields.routeMethodPlaceholder': 'GET',

  // menus status options
  'menus.statusOptions.enabled': 'Enabled',
  'menus.statusOptions.disabled': 'Disabled',

  // menus success/error messages
  'menus.success.created': 'Menu created successfully',
  'menus.success.updated': 'Menu updated successfully',
  'menus.success.deleted': 'Menu deleted successfully',
  'menus.error.notFound': 'Menu not found',
  'menus.error.noResourceId': 'Resource ID is required',
  'menus.error.loadFailed': 'Failed to load menu details',
  'menus.error.createFailed': 'Failed to create menu',
  'menus.error.updateFailed': 'Failed to update menu',
  'menus.error.deleteFailed': 'Failed to delete menu',

  // ============== roles ==============
  'roles.title': 'Roles',
  'roles.description': 'Manage roles and permissions',
  'roles.create': 'Create Role',
  'roles.createTitle': 'Create Role',
  'roles.createDescription': 'Add a new role with permissions',
  'roles.editTitle': 'Edit Role',
  'roles.editDescription': 'Update role information',
  'roles.viewTree': 'View Role Tree',
  'roles.treeTitle': 'Role Hierarchy',
  'roles.treeDescription': 'View roles in a hierarchical tree structure',
  'roles.application': 'Application',
  'roles.createSuccess': 'Role created successfully',
  'roles.updateSuccess': 'Role updated successfully',
  'roles.deleteSuccess': 'Role deleted successfully',
  'roles.statusUpdateSuccess': 'Role status updated successfully',
  'roles.deleteConfirmTitle': 'Delete Role',
  'roles.deleteConfirmDescription':
    'Are you sure you want to delete this role? This action cannot be undone.',
  'roles.searchPlaceholder': 'Search roles by name...',
  'roles.notFound': 'Role not found',
  'roles.noRoles': 'No roles found',
  'roles.name': 'Name',
  'roles.code': 'Code',
  'roles.parentRole': 'Parent Role',
  'roles.noParentRole': 'No Parent (Root Role)',
  'roles.status': 'Status',
  'roles.createdAt': 'Created At',
  'roles.updatedAt': 'Updated At',
  'roles.id': 'ID',
  'roles.enable': 'Enable',
  'roles.disable': 'Disable',
  'roles.namePlaceholder': 'Enter role name',
  'roles.codePlaceholder': 'Enter role code',
  'roles.codeHelpText':
    'Unique identifier for this role (alphanumeric, underscore, and hyphen only)',
  'roles.descriptionPlaceholder': 'Enter role description',
  'roles.parentRolePlaceholder': 'Select parent role (optional)',
  'roles.parentRoleHelpText':
    'Select a parent role to create a hierarchical structure',
  'roles.basicInformation': 'Basic Information',
  'roles.statusOptions.enabled': 'Enabled',
  'roles.statusOptions.disabled': 'Disabled',

  // ============== resources ==============
  'resources.title': 'Resources',
  'resources.description': 'Description',
  'resources.create': 'Create Resource',
  'resources.createTitle': 'Create Resource',
  'resources.createDescription': 'Add a new backend resource',
  'resources.editTitle': 'Edit Resource',
  'resources.editDescription': 'Update resource information',
  'resources.createSuccess': 'Resource created successfully',
  'resources.updateSuccess': 'Resource updated successfully',
  'resources.deleteSuccess': 'Resource deleted successfully',
  'resources.deleteConfirmTitle': 'Delete Resource',
  'resources.deleteConfirmDescription':
    'Are you sure you want to delete this resource? This action cannot be undone.',
  'resources.searchPlaceholder': 'Search resources by name...',
  'resources.information': 'Resource Information',
  'resources.menuStructure': 'Menu Structure',
  'resources.noDescription': 'No description available',
  'resources.noMenus': 'No menus configured for this resource',
  'resources.empty': 'No resources available',
  'resources.emptyHint':
    'Resources are backend services that provide functionality',
  'resources.fields.id': 'Resource ID',
  'resources.fields.name': 'Name',
  'resources.fields.type': 'Type',
  'resources.fields.typeId': 'Type ID',
  'resources.fields.description': 'Description',
  'resources.fields.namePlaceholder': 'Enter resource name',
  'resources.fields.typeIdPlaceholder': 'Enter resource type ID',
  'resources.fields.typePlaceholder': 'Select resource type',
  'resources.fields.descriptionPlaceholder': 'Enter resource description',
  'resources.error.loadFailed': 'Failed to load resources',
  'resources.error.notFound': 'Resource not found',

  // ============== resourceTypes ==============
  'resourceTypes.title': 'Resource Types',
  'resourceTypes.description':
    'Manage resource types to categorize and organize resources',
  'resourceTypes.create': 'Create Resource Type',
  'resourceTypes.createTitle': 'Create Resource Type',
  'resourceTypes.createDescription': 'Add a new resource type category',
  'resourceTypes.editTitle': 'Edit Resource Type',
  'resourceTypes.editDescription': 'Update resource type information',
  'resourceTypes.createSuccess': 'Resource type created successfully',
  'resourceTypes.updateSuccess': 'Resource type updated successfully',
  'resourceTypes.deleteSuccess': 'Resource type deleted successfully',
  'resourceTypes.deleteConfirmTitle': 'Delete Resource Type',
  'resourceTypes.deleteConfirmDescription':
    'Are you sure you want to delete this resource type? This action cannot be undone.',
  'resourceTypes.searchPlaceholder': 'Search resource types by name...',
  'resourceTypes.empty': 'No resource types available',
  'resourceTypes.emptyHint':
    'Resource types are used to categorize and organize backend resources',
  'resourceTypes.fields.id': 'Resource Type ID',
  'resourceTypes.fields.name': 'Name',
  'resourceTypes.fields.namePlaceholder': 'Enter resource type name',
  'resourceTypes.error.loadFailed': 'Failed to load resource types',
  'resourceTypes.error.notFound': 'Resource type not found',

  // ============== tenants ==============
  'tenants.title': 'Tenants',
  'tenants.description': 'Manage tenant organizations and their configurations',
  'tenants.create': 'Create Tenant',
  'tenants.register': 'Register Tenant',
  'tenants.createTitle': 'Create Tenant',
  'tenants.createDescription': 'Add a new tenant organization to the platform',
  'tenants.editTitle': 'Edit Tenant',
  'tenants.editDescription': 'Update tenant information',
  'tenants.createSuccess': 'Tenant created successfully',
  'tenants.updateSuccess': 'Tenant updated successfully',
  'tenants.deleteSuccess': 'Tenant deleted successfully',
  'tenants.deleteConfirmTitle': 'Delete Tenant',
  'tenants.deleteConfirmDescription':
    'Are you sure you want to delete this tenant? This action cannot be undone.',
  'tenants.searchPlaceholder': 'Search tenants by name...',
  'tenants.notFound': 'Tenant not found',
  'tenants.name': 'Name',
  'tenants.logo': 'Logo',
  'tenants.address': 'Address',
  'tenants.status': 'Status',
  'tenants.createdAt': 'Created At',
  'tenants.updatedAt': 'Updated At',
  'tenants.id': 'ID',
  'tenants.namePlaceholder': 'Enter tenant name',
  'tenants.logoPlaceholder': 'Enter logo URL',
  'tenants.logoHelpText': 'Enter a valid URL for the tenant logo',
  'tenants.logoPreview': 'Logo Preview',
  'tenants.addressPlaceholder': 'Enter tenant address',
  'tenants.basicInformation': 'Basic Information',
  'tenants.statistics': 'Statistics',
  'tenants.applicationCount': 'Applications',
  'tenants.viewApplications': 'View Applications',
  'tenants.statusOptions.active': 'Active',
  'tenants.statusOptions.inactive': 'Inactive',

  // ============== applications ==============
  'applications.title': 'Applications',
  'applications.description': 'Manage applications and their domain bindings',
  'applications.create': 'Create Application',
  'applications.createTitle': 'Create Application',
  'applications.createDescription':
    'Add a new application with domain bindings',
  'applications.editTitle': 'Edit Application',
  'applications.editDescription': 'Update application information and domains',
  'applications.createSuccess': 'Application created successfully',
  'applications.updateSuccess': 'Application updated successfully',
  'applications.deleteSuccess': 'Application deleted successfully',
  'applications.initializeSuccess': 'Application initialized successfully',
  'applications.deleteConfirmTitle': 'Delete Application',
  'applications.deleteConfirmDescription':
    'Are you sure you want to delete this application? This action cannot be undone.',
  'applications.searchPlaceholder': 'Search applications by name...',
  'applications.allTenants': 'All Tenants',
  'applications.allStatuses': 'All Statuses',
  'applications.notFound': 'Application not found',
  'applications.name': 'Name',
  'applications.type': 'Type',
  'applications.logo': 'Logo',
  'applications.domains': 'Domains',
  'applications.id': 'ID',
  'applications.secret': 'Secret',
  'applications.tenant': 'Tenant',
  'applications.status': 'Status',
  'applications.createdAt': 'Created At',
  'applications.updatedAt': 'Updated At',
  'applications.resource': 'Resource',
  'applications.namePlaceholder': 'Enter application name',
  'applications.typePlaceholder': 'Enter application type',
  'applications.logoPlaceholder': 'Enter logo URL',
  'applications.logoHelpText': 'Enter a valid URL for the application logo',
  'applications.logoPreview': 'Logo Preview',
  'applications.secretPlaceholder': 'Enter secret (optional, auto-generated)',
  'applications.resourcePlaceholder': 'Select resource (optional)',
  'applications.tenantPlaceholder': 'Select tenant',
  'applications.selectTenant': 'Select a tenant',
  'applications.basicInformation': 'Basic Information',
  'applications.domainConfiguration': 'Domain Configuration',
  'applications.initialize': 'Initialize',
  'applications.initializeTitle': 'Initialize Application',
  'applications.initializeDescription':
    'Initialize this application from a resource template',
  'applications.secretWarning':
    '⚠️ Important: Save the application secret shown above. It will not be displayed again for security reasons.',
  'applications.copySecret': 'Copy Secret',
  'applications.secretCopied': 'Secret copied to clipboard',
  'applications.statusOptions.active': 'Active',
  'applications.statusOptions.inactive': 'Inactive',
  'applications.typeOptions.web': 'Web Application',
  'applications.typeOptions.mobile': 'Mobile Application',
  'applications.typeOptions.desktop': 'Desktop Application',
  'applications.typeOptions.api': 'API Service',

  // ============== dashboard ==============
  'dashboard.title': 'Dashboard',
  'dashboard.description':
    'System overview with statistics and recent activities',
  'dashboard.welcome': 'Welcome to Resource Admin',
  'dashboard.overview': 'System Overview',
  'dashboard.statistics': 'Statistics',
  'dashboard.totalTenants': 'Total Tenants',
  'dashboard.totalApplications': 'Total Applications',
  'dashboard.activeTenants': 'Active Tenants',
  'dashboard.inactiveTenants': 'Inactive Tenants',
  'dashboard.activeApplications': 'Active Applications',
  'dashboard.inactiveApplications': 'Inactive Applications',
  'dashboard.recentApplications': 'Recent Applications',
  'dashboard.recentApplicationsDescription': 'Recently created applications',
  'dashboard.noRecentApplications': 'No recent applications',
  'dashboard.viewAll': 'View All',
  'dashboard.lastUpdated': 'Last updated',
  'dashboard.error.title': 'Failed to Load Dashboard',
  'dashboard.error.noData': 'No data available',
  'dashboard.error.retry': 'Retry',
  'dashboard.error.description':
    'Unable to load dashboard data. Please try again.',

  // ============== welcome ==============
  'welcome.title': 'Resource Admin',
  'welcome.description':
    'Configuration management interface for multi-tenant SaaS platform resources',

  // ============== inactiveTenants ==============
  'inactiveTenants.title': 'Inactive Tenant Reminders',
  'inactiveTenants.description':
    'Manage long-term inactive tenants and send reminder notifications',
  'inactiveTenants.ownerEmail': 'Owner Email',
  'inactiveTenants.ownerPhone': 'Owner Phone',
  'inactiveTenants.lastActiveAt': 'Last Active',
  'inactiveTenants.inactiveDays': 'Inactive Days',
  'inactiveTenants.remindCount': 'Reminders Sent',
  'inactiveTenants.lastRemindAt': 'Last Reminder',
  'inactiveTenants.statusNormal': 'Normal',
  'inactiveTenants.statusWarning': 'Warning',
  'inactiveTenants.statusAttention': 'Attention',
  'inactiveTenants.sendReminder': 'Send Reminder',
  'inactiveTenants.remind': 'Remind',
  'inactiveTenants.viewHistory': 'Reminder History',
  'inactiveTenants.config': 'Settings',
  'inactiveTenants.configTitle': 'Reminder Settings',
  'inactiveTenants.inactiveDaysThreshold': 'Inactive Days Threshold',
  'inactiveTenants.inactiveDaysThresholdHelp':
    'Tenants inactive for more than this many days will appear in the list',
  'inactiveTenants.remindIntervalDays': 'Reminder Interval (Days)',
  'inactiveTenants.remindIntervalDaysHelp':
    'Minimum days between reminders for the same tenant',
  'inactiveTenants.maxRemindCount': 'Max Reminder Count',
  'inactiveTenants.maxRemindCountHelp':
    'No more reminders will be sent after reaching this count',
  'inactiveTenants.remindSuccess': 'Reminder sent successfully',
  'inactiveTenants.batchRemindSuccess':
    'Batch reminders sent successfully, {count} sent',
  'inactiveTenants.batchRemind': 'Batch Send Reminders',
  'inactiveTenants.selectedCount': '{count} tenants selected',
  'inactiveTenants.selectAtLeastOne': 'Please select at least one tenant',
  'inactiveTenants.remindHistoryTitle': 'Reminder History for {name}',
  'inactiveTenants.sendSuccess': 'Sent Successfully',
  'inactiveTenants.sendFailed': 'Send Failed',
  'inactiveTenants.noRemindHistory': 'No reminder history',

  // ============== navigation ==============
  'navigation.home': 'Home',
  'navigation.dashboard': 'Dashboard',
  'navigation.tenants': 'Tenants',
  'navigation.applications': 'Applications',
  'navigation.resources': 'Resources',
  'navigation.resourceTypes': 'Resource Types',
  'navigation.menus': 'Menus',
  'navigation.roles': 'Roles',
  'navigation.settings': 'Settings',

  // ============== resource.config ==============
  'resource.config.title': 'Resource Config',
  'resource.config.list': 'Config List',
  'resource.config.create': 'Create Config',
  'resource.config.edit': 'Edit Config',
  'resource.config.key': 'Config Key',
  'resource.config.value': 'Config Value',
  'resource.config.scope': 'Scope',
  'resource.config.remark': 'Remark',
  'resource.config.manage': 'Manage Config',
};
